import React from 'react'
import PropTypes from 'prop-types'
import {
	Card,
	Text,
	Grid,
	GridItem,
	Box,
	Circle,
	Image,
} from '@chakra-ui/react'
import SVGIcon from '../../../assets/svgIcons'

const RenderFloatingOrdCard = props => {
	const {
		cardColor,
		onClick,
		imgSrc,
		OrgName,
		NoofNotifications,
		empDesignation,
		index,
		onClickProps,
	} = props
	return (
		<Card
			w='20rem'
			h='23.75rem'
			bg={cardColor}
			color='white'
			flexDirection='column'
			alignItems='center'
			justifyContent='flex-start'
			borderRadius='15px'
			cursor='pointer'
			p='1rem'
			gap='3.375rem'
			border='1px solid rgb(238 238 238 / 50%)'
			onClick={() => onClick(onClickProps)}
			mt={index !== 0 && '-19.75rem'}
			zIndex={index}
		>
			<Grid
				w='100%'
				templateRows='repeat(2, 1fr)'
				templateColumns='1fr 4fr 1fr'
				gridColumnGap='1rem'
				alignItems='center'
				justifyContent='center'
			>
				<GridItem rowSpan={2}>
					{/* <Image
						src={imgSrc}
						fallbackSrc={defaultOrgIcon}
						maxW='2rem'
						maxH='2rem'
						filter='brightness(0) invert(1)'
					/> */}
					{!!imgSrc ? (
						<Image
							src={imgSrc}
							maxW='2rem'
							maxH='2rem'
							filter='brightness(0) invert(1)'
						/>
					) : (
						<SVGIcon
							iconName='IdCardGreneLogoSvg'
							svgProps={{
								width: '32',
								height: '32',
								viewBox: '0 0 32 32',
							}}
							// pathProps={{ fill: '#009B76' }}
						/>
					)}
				</GridItem>
				<GridItem>
					<Text
						fontWeight='900'
						fontSize='1rem'
						lineHeight='1.375rem'
						color='white'
					>
						{OrgName}
					</Text>
				</GridItem>
				<GridItem rowSpan={2}>
					<Box display='none' pr={2}>
						<Circle
							fontWeight='900'
							fontSize='1.125rem'
							bg='#FFDE55'
							color='black'
							size='1.875rem'
						>
							{NoofNotifications}
						</Circle>
					</Box>
				</GridItem>
				<GridItem>
					<Text
						fontWeight='400'
						fontSize='0.75rem'
						lineHeight='1.rem'
						color='white'
					>
						{empDesignation}
					</Text>
				</GridItem>
			</Grid>
			{/* <Image
				src={imgSrc}
				fallbackSrc={defaultOrgIcon}
				maxW='11.125rem'
				maxH='11.125rem'
				filter='brightness(0) invert(1)'
			/> */}
			{!!imgSrc ? (
				<Image
					src={imgSrc}
					maxW='11.125rem'
					maxH='11.125rem'
					filter='brightness(0) invert(1)'
				/>
			) : (
				<SVGIcon
					iconName='OrgCardGreneLogoSvg'
					svgProps={{
						width: '64',
						height: '60',
						viewBox: '0 0 64 60',
					}}
					// pathProps={{ fill: '#009B76' }}
				/>
			)}
		</Card>
	)
}

RenderFloatingOrdCard.propType = {
	imgSrc: PropTypes.string,
	cardColor: PropTypes.string,
	OrgName: PropTypes.string,
	empDesignation: PropTypes.string,
	NoofNotifications: PropTypes.number.isRequired,
	onClick: PropTypes.func,
}

export { RenderFloatingOrdCard }
